import { actionCreatorFactory } from 'typescript-fsa';
import { IGridDataHandlers, ISymbolListResponseCounters } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { INode } from '@cbridge-packages/node';
import { IServer } from '@cbridge-packages/server';
import { IStream } from '@cbridge-packages/stream';
import {
  ISymbolClientList, ISymbolClientNodeKey, ISymbolClientDetails, ISymbolClientServerKey, ISymbolClientUpdate, ISymbolClientForm,
  IServerSymbolIdentifier, INodeSymbolIdentifier,
} from './symbolClient.interface';

export namespace SymbolClientAction {
  const actionCreator = actionCreatorFactory('SymbolClient');

  export const reload = actionCreator('RELOAD');

  export const load = actionCreator.async<IServerSymbolIdentifier | INodeSymbolIdentifier, ISymbolClientDetails, IApiErrorParams>('LOAD');
  export const loadListFromNode = actionCreator.async<ISymbolClientNodeKey & IGridDataHandlers, ISymbolClientList, IApiErrorParams>('LOAD_LIST_FROM_NODE');
  export const loadListFromServer = actionCreator.async<ISymbolClientServerKey & IGridDataHandlers, ISymbolClientList, IApiErrorParams>('LOAD_LIST_FROM_SERVER');

  interface ISymbolClientCountersParams {
    nodeId?: INode['nodeId'];
    serverId?: IServer['serverId'];
    streamId?: IStream['streamId'];
  }

  export const loadCounters = actionCreator.async<ISymbolClientCountersParams, ISymbolListResponseCounters, IApiErrorParams>('LOAD_COUNTERS');

  export const processing = actionCreator.async<void, void, void>('PROCESSING');

  interface ISymbolClientCreateParams extends ISymbolClientForm, Pick<IResolverMeta, 'reject'> {
    serverId?: IServer['serverId']; //Used for redirect after success
  }

  interface ISymbolClientUpdateParams extends ISymbolClientUpdate, IResolverMeta {
    serverId?: IServer['serverId']; //Used for redirect after success
  }

  export const create = actionCreator.async<ISymbolClientCreateParams, void, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ISymbolClientUpdateParams, void, IApiErrorParams>('UPDATE');

  interface ISymbolClientRemoveParams {
    nodeId: INode['nodeId'];
    clientSymbolName: string;
  }

  export const remove = actionCreator.async<ISymbolClientRemoveParams, void, IApiErrorParams>('REMOVE');

  export interface IBulkRemoveSymbols {
    nodeId: INode['nodeId'];
    clientSymbolNames: string[];
  }
  export const bulkRemove = actionCreator.async<IBulkRemoveSymbols, void, IApiErrorParams>('BULK_REMOVE');

  interface IExportFileParams {
    nodeId?: INode['nodeId'];
    serverId?: IServer['serverId'];
    showUnmapped?: boolean;
    sort?: string[];
    search?: string;
    streamId?: number;
    symbolGroup?: string;
  }

  export const exportFile = actionCreator.async<IExportFileParams, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
